export default "__VITE_ASSET__EmUNjw4R__"